//Install
import React from "react";
//Install
import "swiper/css";
//Install
import "swiper/css/navigation";
//Install
import "swiper/css/pagination";
//Install
import "bootstrap/dist/css/bootstrap.min.css";
//Install
import "./App.css";
//Install
import "./Responsive.css";
//Install
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
//Install
import Header from "./Component/Header";
//Install
import Corporation from "./Component/Tab/Corporation/Default";
//Install
import History from "./Component/Tab/History/Default";
//Install
import Country from "./Component/Tab/Country/Default";
//Install
import Document from "./Component/Tab/Document/Default";
//Install
import Panel from "./Component/Tab/Services/Panel/Default";
//Install
import Market from "./Component/Tab/Services/Market/Default";
//Install
import Contracting from "./Component/Tab/Services/Contracting/Default";
//Install
import Energy from "./Component/Tab/Services/Energy/Default";
//Install
import Plant from "./Component/Tab/Services/Plant/Default";
//Install
import Project from "./Component/Tab/Project/Default";
//Install
import Sustainability from "./Component/Tab/Sustainability/Default";
//Install
import Career from "./Component/Tab/Career/Default";
//Install
import Contact from "./Component/Tab/Contact/Default";
//Install
import Main from "./Component/Main";
//Install
import Home from "./Component/World/Uk/Main";
//Install
import About_EN from "./Component/World/Uk/Tab/Corporation/Default";
//Install
import Country_EN from "./Component/World/Uk/Tab/Country/Default";
//Install
import History_EN from "./Component/World/Uk/Tab/History/Default";
//Install
import Document_EN from "./Component/World/Uk/Tab/Document/Default";
//Install
import Market_EN from "./Component/World/Uk/Tab/Services/Market/Default";
//Install
import Panel_EN from "./Component/World/Uk/Tab/Services/Panel/Default";
//Install
import Contracting_EN from "./Component/World/Uk/Tab/Services/Contracting/Default";
//Install
import Energy_EN from "./Component/World/Uk/Tab/Services/Energy/Default";
//Install
import Plant_EN from "./Component/World/Uk/Tab/Services/Plant/Default";
//Install
import Project_EN from "./Component/World/Uk/Tab/Project/Default";
//Install
import Sustainability_EN from "./Component/World/Uk/Tab/Sustainability/Default";
//Install
import Career_EN from "./Component/World/Uk/Tab/Career/Default";
//Install
import Contact_EN from "./Component/World/Uk/Tab/Contact/Default";
//Install
import Azerbaijan from "./Component/World/Az/Main"
//Install
import Haqqimizda from "./Component/World/Az/Tab/Haqqimizda/Default";
//Install
import Tarixce from "./Component/World/Az/Tab/Tarixce/Default";
//Install
import Filiallar from "./Component/World/Az/Tab/Filiallar/Default";
//Install
import Sened from "./Component/World/Az/Tab/Sened/Default";
//Install
import Layihalar from "./Component/World/Az/Tab/Layihalar/Default";
//Install
import Davamliliq from "./Component/World/Az/Tab/Davamliliq/Default";
//Install
import Caryera from "./Component/World/Az/Tab/Caryera/Default";
//Install
import Elaqe from "./Component/World/Az/Tab/Elaqe/Default";
//Install
import Isiqlandirma from "./Component/World/Az/Tab/Isiqlandirma/Default";
//Install
import Pano from "./Component/World/Az/Tab/Panel/Default";
//Install
import Elektrik from "./Component/World/Az/Tab/Elektrik/Default";
//Install
import Enerji from "./Component/World/Az/Tab/Enerji/Default";
//Install
import Gerilim from "./Component/World/Az/Tab/Middle/Default";
//Install
import Footer from "./Component/Footer";

//Element
function App() {
  //Element
  return (
    //Element
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={ <Main /> }></Route>
          <Route path="/hakkimizda" element={ <Corporation /> }></Route>
          <Route path="/tarihce" element={ <History /> }></Route>
          <Route path="/subeler" element={ <Country /> }></Route>
          <Route path="/yetki-belgeleri" element={ <Document /> }></Route>
          <Route path="/pano-imalati" element={ <Panel /> }></Route>
          <Route path="/aydinlatma" element={ <Market /> }></Route>
          <Route path="/elektrik-taahhut" element={ <Contracting /> }></Route>
          <Route path="/yenilenebilir-enerji" element={ <Energy /> }></Route>
          <Route path="/orta-gerilim-tesisleri" element={ <Plant /> }></Route>
          <Route path="/projeler" element={ <Project /> }></Route>
          <Route path="/surdurulebilirlik" element={ <Sustainability /> }></Route>
          <Route path="/kariyer" element={ <Career /> }></Route>
          <Route path="/iletisim" element={ <Contact /> }></Route>
          <Route path="/en" element={ <Home /> }></Route>
          <Route path="/en/about-us" element={ <About_EN /> }></Route>
          <Route path="/en/offices" element={ <Country_EN /> }></Route>
          <Route path="/en/history" element={ <History_EN /> }></Route>
          <Route path="/en/authorization-certificates" element={ <Document_EN /> }></Route>
          <Route path="/en/lighting-systems" element={ <Market_EN /> }></Route>
          <Route path="/en/electrical-panel-manufacturing" element={ <Panel_EN /> }></Route>
          <Route path="/en/electrical-contracting" element={ <Contracting_EN /> }></Route>
          <Route path="/en/renewable-energy" element={ <Energy_EN /> }></Route>
          <Route path="/en/medium-voltage-systems" element={ <Plant_EN /> }></Route>
          <Route path="/en/projects" element={ <Project_EN /> }></Route>
          <Route path="/en/sustainability" element={ <Sustainability_EN /> }></Route>
          <Route path="/en/career" element={ <Career_EN /> }></Route>
          <Route path="/en/contact" element={ <Contact_EN /> }></Route>
          <Route path="/az" element={ <Azerbaijan /> }></Route>
          <Route path="/az/haqqimizda" element={ <Haqqimizda /> }></Route>
          <Route path="/az/tarixce" element={ <Tarixce /> }></Route>
          <Route path="/az/filiallar" element={ <Filiallar /> }></Route>
          <Route path="/az/səlahiyyət-sənədləri" element={ <Sened /> }></Route>
          <Route path="/az/layiheler" element={ <Layihalar /> }></Route>
          <Route path="/az/davamliliq" element={ <Davamliliq /> }></Route>
          <Route path="/az/karyera" element={ <Caryera /> }></Route>
          <Route path="/az/elaqe" element={ <Elaqe /> }></Route>
          <Route path="/az/isiqlandirma" element={ <Isiqlandirma /> }></Route>
          <Route path="/az/panel-istehsali" element={ <Pano /> }></Route>
          <Route path="/az/elektrik-muqavilesi" element={ <Elektrik /> }></Route>
          <Route path="/az/yenilene-bilen-enerji" element={ <Enerji /> }></Route>
          <Route path="/az/orta-gerginlik-tesisleri" element={ <Gerilim /> }></Route>
          <Route path="*" element={ <Navigate to="/" /> } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
//Element
export default App;